export default "__VITE_ASSET__mdVXEIJP__"